document.addEventListener("DOMContentLoaded", function () {
    const filters = document.querySelectorAll(".filter-option");
    const cards = document.querySelectorAll(".subscription-card");

    function filterSubscriptions() {
        // Get currently selected values
        const selectedStatus = document.querySelector('.filter-group[data-filter="status"] .active')?.getAttribute("data-value") || "";

        cards.forEach(card => {
            const cardStatus = card.getAttribute("data-filter-status"); // "active", "expired", "pending"

            // Check if the card matches the selected filters
            const matchesStatus = !selectedStatus || cardStatus === selectedStatus;

            if (matchesStatus) {
                card.setAttribute("aria-hidden", "false");
                card.removeAttribute("tabindex");
                card.style.display = "block"; // Show matching items
            } else {
                card.setAttribute("aria-hidden", "true");
                card.setAttribute("tabindex", "-1");
                card.style.display = "none"; // Hide non-matching items
            }
        });
    }

    filters.forEach(filter => {
        filter.addEventListener("click", function () {
            // Remove 'active' class from other options in the same filter group
            this.closest(".filter-group").querySelectorAll(".filter-option").forEach(btn => btn.classList.remove("active"));

            // Add 'active' class to the clicked option
            this.classList.add("active");

            // Apply filtering while keeping both selections
            filterSubscriptions();
        });
    });

    // Ensure the initial filter state is respected on page load
    filterSubscriptions();
});